export default __webpack_public_path__ + "static/media/sorinProfile.b058190b.png";